import axios from "axios";
import { SuperAdminURL } from "../../../../config/UrlEndPoint";

export const URL = `${SuperAdminURL}users`;

export function findUsers(queryParams) {
  return axios.get(`${URL}`, { params: queryParams });
}

export function getSuperAdminAllRole() {
  return axios.get(`${URL}/role`);
}

export function createSuperAdminUser(payload) {
  return axios.post(`${URL}`, payload);
}

export function findSuperAdminUserById(id) {
  return axios.get(`${URL}/${id}`);
}

export function updateSuperAdminUser(id, payload) {
  return axios.put(`${URL}/${id}`, payload);
}
